import styled from 'styled-components';

export const EditButtons = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Capitalize = styled.span`
  text-transform: capitalize;
`;

export const CommentText = styled.div`
  word-break: break-all;
`;
